<div class="card card-custom instance-setting-content">
    <div class="row breadcume">
        <div class="col-md-8">
            <div class="row">
                <div class="breadcume-item" *ngFor="let data of breadcrumbData">
                    <h3>
                        <a href="javascript:void(0)" (click)="refreshData(data)">{{ data.name }}</a>
                        <i class="fa fa-angle-right" aria-hidden="true" style="font-size: 20px; margin: 0px 10px; color: #337ab7"></i>
                    </h3>
                </div>
            </div>
        </div>
        <div class="col-md-4 text-center mt-3" *ngIf="_breadcrumbData">
            <mat-checkbox class="example-margin al" type="checkbox" [checked]="selectAll" (change)="selectionChangeAll($event)">
                Select all/ Deselect all
            </mat-checkbox>
        </div>
    </div>

    <div class="card-body pt-10 accordian-section new-accordian-scroll">
        <div class="row">
            <div class="col-md-4 mb-5" *ngFor="let item of allowedItemsToDisplay">
                <div class="listing_view">
                    <section class="example-section">
                        <p>
                            <mat-checkbox
                                class="example-margin"
                                type="checkbox"
                                [checked]="getGroupCheckedStatus(item)"
                                [indeterminate]="getPartiallySelectedGroupCheckedStatus(item)"
                                (change)="selectionChange($event, item)"
                                [id]="item.allowedItemId"
                            ></mat-checkbox>
                            <a [ngClass]="item.items ? 'pointer-link' : 'arrow-link'" (click)="loadData(item)">{{ item.name }}</a>
                        </p>
                    </section>
                </div>
            </div>
        </div>
    </div>

    <!--<div class="row">
      <div class="col-md-4 child_section" *ngFor="let item of allowedItem">
        <a>
          <mat-checkbox class="example-margin1" type="checkbox" value="false"
                        id="item.allowedItemTypeId"> {{item.name}}</mat-checkbox>
        </a>
      </div>
    </div>-->
</div>
